import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';
import { Menu as SemanticUIMenu } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props/use-semantic-ui-props';
import './Menu.css';
var defaultProps = {
  className: ''
};
export default function Menu(_ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getMenuProps = _useSemanticUiProps.getMenuProps;
  var menuProps = getMenuProps(props);
  return /*#__PURE__*/React.createElement(SemanticUIMenu.Menu, _extends({
    className: "submenu ".concat(className)
  }, menuProps), children);
}
Menu.defaultProps = defaultProps;